export default "__VITE_ASSET__g3TmVVHA__"